import { FC, useEffect, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { getPCDInfo } from '@/common/utils/map';
import { chancePointEstimatedSales } from '@/common/api/expandStore/chancepoint';
import { isNotEmpty } from '@lhb/func';
import { ControlType, setComValue } from '@/common/components/business/DynamicComponent/config';

// import cs from 'classnames';
// import styles from './entry.module.less';

interface EstimateSalesKWKProps {
  form: any;
  addressVal: any;
  businessInfoValue: any;
  salesFactorOfKWK: any;
  tiledFormDataRef: any;
};

/**
 * @Description 卡旺卡门店预计销售额定制组件值的计算
 */
const EstimateSalesKWK: FC<EstimateSalesKWKProps> = ({
  form,
  addressVal,
  businessInfoValue,
  salesFactorOfKWK, // 影响因子
  tiledFormDataRef,
}) => {

  const [theoreticalSales, setTheoreticalSales] = useState<number | null>(); // 开店区域理论月度销售额
  // 选择位置获取对应的理论月度销售额
  useEffect(() => {
    const targetCom = tiledFormDataRef.current?.find((item: any) => item.controlType === ControlType.MATCH_BUSINESS_CIRCLE.value);

    // 有匹配商圈，按商圈变动信息来更新请求预测额，此处不再重复处理
    if (targetCom) return;

    const { lng, lat } = addressVal || {};
    if (!(+lng && +lat)) return;
    methods.getTheoreticalSales({ lng: +lng, lat: +lat });
  }, [addressVal]);

  useEffect(() => {
    const { lng, lat, clusterId: modelClusterId, modelConfigId } = businessInfoValue || {};
    if (!(+lng && +lat)) return;
    methods.getTheoreticalSales({ modelClusterId, modelConfigId, lng: +lng, lat: +lat });
  }, [businessInfoValue]);

  useEffect(() => {
    const targetCom = tiledFormDataRef.current?.find((item: any) => item.controlType === ControlType.ESTIMATE_SALES_KWK.value);
    if (isNotEmpty(theoreticalSales) && targetCom) { // 理论月度销售额有值时
      // console.log(`salesFactorOfKWK`, salesFactorOfKWK);
      const factorArr: number[] = Object.values(salesFactorOfKWK || {});
      // console.log(`factorArr`, factorArr);
      // console.log(`theoreticalSales`, theoreticalSales);
      const factorVal = factorArr?.reduce((acc: number, cur: number) => (acc + cur), 0);
      // console.log(`factorVal`, factorVal);
      const value = theoreticalSales as number * (1 + factorVal);
      // console.log(`value`, value);
      const formattingValue = isNotEmpty(+value) ? +value.toFixed(0) : ''; // 产品说整数显示
      // console.log(`formattingValue`, formattingValue);
      form.setFieldsValue({
        [targetCom.identification]: formattingValue
      });
      setComValue(targetCom, formattingValue);
      return;
    }
    // console.log(`进入清空逻辑`);
    // 没值时，清空
    targetCom && setComValue(targetCom, '');
    targetCom && form.setFieldsValue({
      [targetCom.identification]: '',
    });

  }, [theoreticalSales, salesFactorOfKWK]);

  const methods = useMethods({
    getTheoreticalSales: async (params: any) => {
      // 城市id这里只做检查用，不参与请求
      const { lng, lat } = params || {};
      const pcdInfo: any = await getPCDInfo([+lng, +lat]);
      const { cityId } = pcdInfo || {};
      // 不属于中国城市的时候，跳过处理，避免接口请求报错
      if (!cityId) return;

      const data = await chancePointEstimatedSales(params, { needCancel: false });
      const { saleAmount } = data || {};
      setTheoreticalSales(saleAmount);
    }
  });
  return (
    <></>
  );
};

export default EstimateSalesKWK;
